import { useMsal } from '@azure/msal-react';
import { Role } from '@components/PermissionGate/RolePermissionConfig';

export const useRoleCheck = (roles: Role[]) => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const accountRoles = account?.idTokenClaims?.roles as Role[];
  const lowerCaseAccountRoles = new Set(accountRoles.map((accountRole) => accountRole.toLowerCase()));
  return roles.some((role) => lowerCaseAccountRoles.has(role.toLowerCase()));
};
